import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlides';
import currencyReducer from './slices/currencySlides';
import suscriptionReducer from './slices/suscriptionSlides';
import eDocumentReducer from './slices/eDocumentSlides';

export const store = configureStore({
    reducer: {
        user: userReducer,
        currency: currencyReducer,
        suscription: suscriptionReducer,
        eDocument: eDocumentReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
